import opConfig from 'openpathConfig';

export const getDmpUrl = () => opConfig.DMP_URL;
